import React from 'react';

interface IRHFLegendProps {
    title: string;
}
const RHFLegend = (props: IRHFLegendProps) => {
    return (
        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
            <legend style={{ marginLeft: '2rem', padding: '0 .5rem', fontSize: '1.7rem' }}>{props.title}</legend>
        </fieldset>
    );
};

export default RHFLegend;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFLegend.tsx